"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Attribution;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _image = require("@site/pattern-library-core/image");
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const AttributionWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "AttributionWrapper",
  class: "pl-a9vk0ad"
});
const AttributionBlock = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "AttributionBlock",
  class: "pl-a9reyrt",
  vars: {
    "a9reyrt-0": [({
      rowPosition
    }) => rowPosition === 'left' ? `'attr browser-img'` : `'browser-img attr'`],
    "a9reyrt-1": [({
      rowPosition
    }) => rowPosition],
    "a9reyrt-2": [({
      rowPosition
    }) => rowPosition === 'left' ? `'browser-img attr'` : `'attr browser-img'`],
    "a9reyrt-4": [({
      browserImage
    }) => browserImage ? 'initial' : '100%'],
    "a9reyrt-5": [({
      columnPosition
    }) => columnPosition === 'top' ? `'attr' 'browser-img' '.'` : `'.' 'browser-img' 'attr'`]
  }
});
const BrowserImage = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "BrowserImage",
  class: "pl-b141x640",
  vars: {
    "b141x640-0": [({
      rowPosition
    }) => rowPosition]
  }
});
const AttributionText = /*#__PURE__*/(0, _react2.styled)("figcaption")({
  name: "AttributionText",
  class: "pl-a1g2wxte"
});

/**
 * Render Attribution
 *
 * @param {Object} props React props for Attribution
 * @param {string} props.attribution Attribution text
 * @param {string} props.rowPosition Attribution position on mobile & tablet
 * @param {string} props.columnPosition Attribution position for laptop and above
 * @param {Object} props.browserImage Browser image URL and alt text
 * @returns {React.ReactElement} Homepage Marquee Attribution
 * @public
 */
function Attribution({
  attribution,
  rowPosition = 'left',
  columnPosition = 'bottom',
  browserImage
}) {
  return /*#__PURE__*/_react.default.createElement(AttributionWrapper, {
    "data-cy": "attribution"
  }, /*#__PURE__*/_react.default.createElement(AttributionBlock, {
    rowPosition: rowPosition,
    columnPosition: columnPosition,
    browserImage: browserImage
  }, browserImage && /*#__PURE__*/_react.default.createElement(BrowserImage, {
    src: browserImage.url,
    alt: browserImage.altText,
    rowPosition: rowPosition
  }), attribution && /*#__PURE__*/_react.default.createElement(AttributionText, null, (0, _patternLibraryUtils.formatAttribution)(attribution))));
}
Attribution.propTypes = {
  attribution: _propTypes.default.string,
  rowPosition: _propTypes.default.oneOf(['left', 'right']),
  columnPosition: _propTypes.default.oneOf(['top', 'bottom']),
  browserImage: _propTypes.default.shape(_image.imgPropShape)
};